const STORAGE = {
  COOKIE: {
    IDENTITY: {
      BASE: 'identity',
      ACCESS_TOKEN: 'identity:access-token',
      REFRESH_TOKEN: 'identity:refresh-token',
      EXPIRE_AT: 'identity:expire-at',
      TOKEN_TYPE: 'identity:token-type',
    },
  },
  LOCAL: {
    DEFAULT: {
      VERSION: '2.9.4',
    },
    SEARCH: {
      BASE: 'search',
      HISTORY: 'search:history',
    },
    WATERMARK: {
      BASE: 'watermark',
      PLACEHOLDER: 'watermark:placeholder',
    },
  },
  SESSION: {
    DEFAULT: {},
  },
  HEADER: {
    DEFAULT: {
      AUTHORIZATION: 'Authorization',
    },
  },
} as const;

export { STORAGE };
